import i18n from '@/i18n';

type Field = 'name' | 'description';

// Badges, missions and rewards are named in the database (English). Translate by
// slug (scout:catalogItems.<slug>.name); when only the English name is known (mission
// toasts), find the slug through the English catalog.
function slugForEnglishName(name: string): string | undefined {
  const catalog = i18n.getResourceBundle('en', 'scout')?.catalogItems as Record<string, { name: string }> | undefined;
  if (!catalog) return undefined;
  return Object.keys(catalog).find((slug) => catalog[slug]?.name === name);
}

export function catalogText(slug: string | undefined, field: Field, fallback: string | null | undefined): string {
  const key = slug ?? (fallback ? slugForEnglishName(fallback) : undefined);
  // Custom or unknown entries (no catalog key) keep their own name.
  if (!key || !i18n.exists(`scout:catalogItems.${key}.${field}`)) return fallback ?? '';
  return i18n.t(`scout:catalogItems.${key}.${field}`);
}
